<template>
  <div>
    <h2>STATUS</h2>
    <b-row id="room-status">
      <b-col>
        Room Status:
      </b-col>
      <b-col>
        {{ sessionStatus.roomStatus }}
      </b-col>
    </b-row>
    <b-row id="video-status">
      <b-col>
        Video Status:
      </b-col>
      <b-col>
        {{ sessionStatus.isVideoEnabled ? 'Enabled' : 'Disabled' }}
      </b-col>
    </b-row>
    <b-row id="audio-status">
      <b-col>
        Audio Status:
      </b-col>
      <b-col>
        {{ sessionStatus.isAudioEnabled ? "Enabled" : "Disabled" }}
      </b-col>
    </b-row>
    <b-row id="layout-status">
      <b-col>
        Layout Status:
      </b-col>
      <b-col>
        {{ sessionStatus.layoutStatus }}
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Sessions_Stage_Status",
  components: {  },
  props: {
    session: {
      type: Object,
      default: () => {}
    },
    profile: {
      type: Object,
      default: () => {}
    },
    sessionStatus: {
      type: Object,
      default: () => {}
    },
  },
  mounted() {},
  computed: {},
  methods: { },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
